import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import Overlay from '../../../../presentation/Overlay';
import DeleteItemDialog from '../../../../presentation/DeleteItemDialog';
import ReactGrid, {
  ReactGridHeader,
  ReactGridColumn,
  ReactGridBody,
  ReactGridDropDownCell,
  ReactGridTextboxCell,
  ReactGridIconCell,
  ReactGridReadOnlyCell,
  ReactGridNoRowsTemplate,
  ReactGridRowTemplate,
} from '../../../../presentation/ReactGrid';

class WholesaleDefaultProgramsGrid extends Component {
  constructor( props ) {
    super( props );
    this.title = 'Default Programs';
    this.state = {
      rows: props.rows === undefined ? [] : props.rows,
      numberTypes: props.numberTypes === undefined ? [] : props.numberTypes,
      showDeleteDialog: false,
      itemToDelete: {}
    };

    this.onCellChanged = this.onCellChanged.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );
    this.onHandleClickCancel = this.onHandleClickCancel.bind( this );
    this.onHandleClickConfirmDelete = this.onHandleClickConfirmDelete.bind( this );
  }

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = true;

    newState.rows = props.rows === undefined ? state.rows : props.rows;
    newState.numberTypes = props.numberTypes === undefined ? state.numberTypes : props.numberTypes;

    if ( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  onCellChanged( args ) {
    let rows = this.state.rows;
    if ( args !== undefined ) {
      if ( args.rowIndex >= 0 && args.newrow !== undefined ) {
        rows[args.rowIndex] = args.newrow;
        this.setState( {
          rows: rows
        } );
      }
    }
  }

  onHandleClickCancel( e ) {
    this.setState( {
      showDeleteDialog: false
    } );
  }

  onHandleClickConfirmDelete( e ) {
    if ( this.props.onDeleteItem !== undefined ) {
      this.setState( {
        showDeleteDialog: false
      }, () => {
        this.props.onDeleteItem( this.state.itemToDelete );
      } );
    }
  }

  onIconClicked( args ) {
    if ( args.iconKey === 'UPDATE' ) {
      if ( this.props.onUpdateItem !== undefined ) {
        this.props.onUpdateItem( args );
      }
    }

    if ( args.iconKey === 'DELETE' ) {
      this.setState( {
        showDeleteDialog: true,
        itemToDelete: args
      } );
    }

    if ( args.iconKey === 'COPY' ) {
      if ( this.props.onCopyItem !== undefined ) {
        this.props.onCopyItem( args );
      }
    }
  }


  getNumberTypeOptions() {
    const options = [];
    const numberTypes = this.state.numberTypes;
    if ( numberTypes !== undefined ) {
      if ( numberTypes.length > 0 ) {
        for ( let index = 0; index < numberTypes.length; index++ ) {
          const row = numberTypes[index];
          options.push( {
            id: row.Number_Type_ID,
            text: row.Number_Type_Description
          } );
        }
      }
    }
    return options;
  }

  getActiveOptions() {
    const options = [
      { id: 0, text: "Not Active" },
      { id: 1, text: "Active" }
    ];
    return options;
  }

  onRenderHeaders() {
    return (
      <ReactGridHeader tagName="header">
        <ReactGridColumn tagName="column" key="COPY" caption="Copy" width="50px" sorted="" datatype="icon" />
        <ReactGridColumn tagName="column" key="NUMBER_TYPE_DESCRIPTION" caption="Number Type" width="200px" sorted="NUMBER_TYPE_DESCRIPTION" datatype="string" />
        <ReactGridColumn tagName="column" key="NUMBER_DIALED" caption="Number Dailed" width="200px" sorted="NUMBER_DIALED" datatype="string" />
        <ReactGridColumn tagName="column" key="DEFAULT_PROGRAMS" caption="Default Programs" width="500px" sorted="" datatype="string" />
        <ReactGridColumn tagName="column" key="ACTIVE_TEXT" caption="Active" width="200px" sorted="ACTIVE_TEXT" datatype="string" />
        <ReactGridColumn tagName="column" key="SAVE" caption="Save" width="50px" sorted="" datatype="icon" />
        <ReactGridColumn tagName="column" key="DELETE" caption="Delete" width="50px" sorted="" datatype="icon" />
        <ReactGridColumn tagName="column" key="" caption="" width="auto" sorted="" datatype="string" />
      </ReactGridHeader>
    );
  }

  onRenderRowsTemplate() {
    const numberTypeOptions = this.getNumberTypeOptions();
    const activeOptions = this.getActiveOptions();
    return (
      <ReactGridRowTemplate tagName='rowTemplate' height='auto'>
        <ReactGridIconCell tagName='iconCell' column={'COPY'} width={'50px'} align={'center'} icon={'icon-fontello-docs-1'} iconKey={'COPY'} toolTip={'Copy Default Program'} bold={false} iconColor="#00796c" />
        <ReactGridDropDownCell tagName='dropDownCell' key={'NUMBER_TYPE_DESCRIPTION'} column={'NUMBER_TYPE_ID'} width={'200px'} align={'center'} options={numberTypeOptions} bold={false} />
        <ReactGridTextboxCell tagName='textboxCell' key={'NUMBER_DIALED'} column={'NUMBER_DIALED'} width={'200px'} align={'center'} bold={false} />
        <ReactGridTextboxCell tagName='textboxCell' key={'DEFAULT_PROGRAMS'} column={'DEFAULT_PROGRAMS'} width={'500px'} align={'center'} bold={false} />
        <ReactGridDropDownCell tagName='dropDownCell' key={'ACTIVE'} column={'ACTIVE'} width={'200px'} align={'center'} options={activeOptions} parameter={'ACTIVE'} bold={false} />
        <ReactGridIconCell tagName='iconCell' column={'SAVE'} width={'50px'} align={'center'} icon={'icon-fontello-floppy-1'} iconKey={'UPDATE'} toolTip={'Save Default Program'} bold={false} iconColor="#00796c" />
        <ReactGridIconCell tagName='iconCell' column={'DELETE'} width={'50px'} align={'center'} icon={'icon-fontello-trash-8'} iconKey={'DELETE'} toolTip={'Delete Default Program'} bold={false} iconColor="#BE000E" />
        <ReactGridReadOnlyCell tagName="readOnlyCell" column='' width='auto' align='center' />
      </ReactGridRowTemplate>
    );
  }

  onRenderNowRowsTemplate() {
    return (
      <ReactGridNoRowsTemplate tagName='noRowTemplate' height='50px'>
        <span>There are not default programs defined</span>
      </ReactGridNoRowsTemplate>
    );
  }

  render() {
    const showOverlay = this.state.showDeleteDialog;

    return (
      <span style={{ width: "100%", height: "100%" }}>
        <ReactGrid
          tagName="grid"
          width="100%"
          height={'auto'}
          dataSource={this.state.rows}
          paging={false}
          pageSize={this.state.rows.length}
          pageIndex={0}
          onCellChanged={this.onCellChanged}
          onIconClicked={this.onIconClicked}
        >
          {this.onRenderHeaders()}
          <ReactGridBody tagName="body">
            {this.onRenderRowsTemplate()}
            {this.onRenderNowRowsTemplate()}
          </ReactGridBody>
        </ReactGrid>
        {
          showOverlay && <Overlay show={showOverlay} />
        }
        {
          this.state.showDeleteDialog &&
          <DeleteItemDialog
            show={this.state.showDeleteDialog}
            layout={{ newbutton: { caption: 'Default Program' } }}
            onCancel={this.onHandleClickCancel}
            onConfirm={this.onHandleClickConfirmDelete}
          />
        }
      </span>
    );
  }
}

class WholesaleDefaultPrograms extends Component {
  constructor( props ) {
    super( props );
    this.title = 'Default Programs';
    this.state = {
      row: props.row === undefined ? {} : props.row,
      addNewItem: false,
      NUMBER_TYPE_ID: -1,
      DEFAULT_PROGRAMS: '',
      ACTIVE: -1,
      newItem: {},
      numberTypes: [],
      programDefaults: [],
      programs: [],
      changed: false
    };

    this.onNewItem = this.onNewItem.bind( this );
    this.onSaveItem = this.onSaveItem.bind( this );
    this.onCancelItem = this.onCancelItem.bind( this );
    this.onInsertItem = this.onInsertItem.bind( this );
    this.onUpdateItem = this.onUpdateItem.bind( this );
    this.onDeleteItem = this.onDeleteItem.bind( this );
    this.onCopyItem = this.onCopyItem.bind( this );

    this.onChangeNumberType = this.onChangeNumberType.bind( this );
    this.onChangeNumberDialed = this.onChangeNumberDialed.bind( this );
    this.onDefaultProgramChange = this.onDefaultProgramChange.bind( this );
    this.onChangeActive = this.onChangeActive.bind( this );
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/
  componentDidMount() {
    this.getData();
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/
  getNumberTypes() {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'types/wholesalenumbertypes' );
      api.get( [] ).then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getDefaultPrograms() {
    const row = this.state.row;
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/defaultprograms' );
      const parameters = [
        { WS_COMPANY_ID: row.Company_ID },
        { NUMBER_TYPE_ID: this.state.NUMBER_TYPE_ID },
        { ACTIVE: this.state.ACTIVE }
      ];
      api.get( parameters ).then( ( result ) => {
        resolve( result );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getData() {
    const callbacks = [];
    callbacks.push( this.getNumberTypes() );
    callbacks.push( this.getDefaultPrograms() );
    const RESULT_INDICES = {
      NUMBER_TYPES: 0,
      DEFAULT_PROGRAMS: 1
    };
    const all = () => Promise.all( callbacks ).then( ( results ) => {
      const numberTypes = results[RESULT_INDICES.NUMBER_TYPES];
      const defaultPrograms = results[RESULT_INDICES.DEFAULT_PROGRAMS];
      this.setState( {
        numberTypes: numberTypes,
        defaultPrograms: defaultPrograms
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
    all();
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/
  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/
  createNewItem() {
    let newItem = { ID: -1, WS_COMPANY_ID: -1, NUMBER_DIALED: '', DEFAULT_PROGRAMS: '', NUMBER_TYPE_ID: 0, ACTIVE: 1 };
    const row = this.state.row;
    if ( row !== undefined ) {
      newItem.WS_COMPANY_ID = row.Company_ID;
    }
    return newItem;
  }
  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/
  onNewItem() {
    const newItem = this.createNewItem();
    this.setState( {
      newItem: newItem,
      addNewItem: true
    } );
  }

  onSaveItem() {
    const newItem = this.state.newItem;
    this.onInsertItem( newItem );
  }

  onInsertItem( args ) {
    const { bugsnag, dispatch } = this.props;
    const alert = new Alerts( bugsnag, dispatch );
    const api = new EtelAPI( 'wholesale/defaultprograms' );
    let rows = this.state.defaultPrograms;
    api.insert( args ).then( ( result ) => {
      rows.unshift( args );
      this.setState( {
        NUMBER_TYPE_ID: -1,
        NUMBER_DIALED: '',
        ACTIVE: -1,
        DEFAULT_PROGRAMS: '',
        defaultPrograms: rows,
        newItem: {},
        addNewItem: false
      }, () => {
        alert.SUCCESS( this.title, 'Successfully saved a new default program.', 2500 );

        this.props.onSave( { row: result.data[0] } );
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onUpdateItem( args ) {
    const { bugsnag, dispatch } = this.props;
    const alert = new Alerts( bugsnag, dispatch );
    const api = new EtelAPI( 'wholesale/defaultprograms' );
    let rows = this.state.defaultPrograms;
    const row = args.row;
    if ( row !== undefined ) {
      const payload = {
        ID: row.ID,
        NUMBER_DIALED: row.NUMBER_DIALED,
        DEFAULT_PROGRAMS: row.DEFAULT_PROGRAMS,
        WS_COMPANY_ID: row.WS_COMPANY_ID,
        NUMBER_TYPE_ID: row.NUMBER_TYPE_ID,
        ACTIVE: row.ACTIVE
      };
      api.update( payload ).then( ( result ) => {
        rows[args.rowIndex] = row;
        this.setState( {
          NUMBER_TYPE_ID: -1,
          NUMBER_DIALED: '',
          ACTIVE: -1,
          DEFAULT_PROGRAMS: '',
          defaultPrograms: rows,
          newItem: {},
          addNewItem: false
        }, () => {
          alert.SUCCESS( this.title, 'Successfully updated default program.', 2500 );

          this.props.onSave( { row: result.data[0] } );
        } );
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    }
  }

  onDeleteItem( args ) {
    const { bugsnag, dispatch } = this.props;
    const alert = new Alerts( bugsnag, dispatch );
    const api = new EtelAPI( 'wholesale/defaultprograms' );
    const ID = args.row.ID;
    if ( ID !== undefined ) {
      api.delete( args.row.ID ).then( ( result ) => {
        this.setState( {
          NUMBER_TYPE_ID: -1,
          NUMBER_DIALED: '',
          ACTIVE: -1,
          DEFAULT_PROGRAMS: '',
          newItem: {},
          addNewItem: false
        }, () => {
          alert.SUCCESS( this.title, 'Successfully deleted default program.', 2500 );
          this.getData();
          this.props.onDelete( args.row );
        } );
      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );
    }
  }

  onCopyItem( args ) {
    const row = args.row;
    let newItem = {
      ID: -1,
      NUMBER_TYPE_ID: row.NUMBER_TYPE_ID,
      NUMBER_DIALED: row.NUMBER_DIALED,
      DEFAULT_PROGRAMS: row.DEFAULT_PROGRAMS,
      WS_COMPANY_ID: row.WS_COMPANY_ID,
      ACTIVE: row.ACTIVE
    };
    this.setState( {
      newItem: newItem,
      addNewItem: true
    } );
  }

  onCancelItem() {
    this.setState( {
      NUMBER_TYPE_ID: -1,
      DEFAULT_PROGRAMS: '',
      ACTIVE: -1,
      newItem: {},
      addNewItem: false
    } );
  }

  onChangeNumberType( e ) {
    if ( this.state.addNewItem === false ) {
      this.setState( {
        NUMBER_TYPE_ID: e.target.value
      }, () => {
        this.getData();
      } );
    } else {
      let newItem = this.state.newItem;
      newItem.NUMBER_TYPE_ID = e.target.value;
      this.setState( {
        newItem: newItem
      } );
    }
  }

  onChangeActive( e ) {
    if ( this.state.addNewItem === false ) {
      this.setState( {
        ACTIVE: e.target.value
      }, () => {
        this.getData();
      } );
    } else {
      let newItem = this.state.newItem;
      newItem.ACTIVE = e.target.value;
      this.setState( {
        newItem: newItem
      } );
    }
  }

  onChangeNumberDialed( e ) {
    let newItem = this.state.newItem;
    newItem.NUMBER_DIALED = e.target.value;
    this.setState( {
      newItem: newItem
    } );
  }

  onDefaultProgramChange( e ) {
    let newItem = this.state.newItem;
    newItem.DEFAULT_PROGRAMS = e.target.value;
    this.setState( {
      newItem: newItem
    } );
  }

  /****************************************************************************
   * RENDERS
  ***************************************************************************/
  onRenderNumberTypeOptions( isNew ) {
    const options = [];
    const numberTypes = this.state.numberTypes;
    if ( isNew === false ) {
      options.push(
        <option key='number-types-option-all' value={-1}>All</option>
      );
    }
    if ( numberTypes !== undefined ) {
      if ( numberTypes.length > 0 ) {
        for ( var index = 0; index < numberTypes.length; index++ ) {
          const row = numberTypes[index];
          const rowKey = 'number-types-option-' + row.Number_Type_ID.toString();
          options.push(
            <option key={rowKey} value={row.Number_Type_ID}>{row.Number_Type_Description}</option>
          );
        }
      }
    }
    return options;
  }

  onRenderActiveOptions( isNew ) {
    const options = [];
    if ( isNew === false ) {
      options.push(
        <option key='active-option-all' value={-1}>All</option>
      );
    }
    options.push(
      <option key='active-option-0' value={0}>Not Active</option>
    );
    options.push(
      <option key='active-option-1' value={1}>Active</option>
    );
    return options;
  }

  onRenderProgramOptions() {
    const options = [];
    const programs = this.state.programs;
    if ( programs !== undefined ) {
      if ( programs.length > 0 ) {
        for ( let index = 0; index < programs.length; index++ ) {
          options.push( {
            value: programs[index].PDNIS, label: programs[index].PDNIS
          } );
        }
      }
    }
    return options;
  }

  render() {
    let filterMessage = '';
    filterMessage = 'Filtered by';

    if ( parseInt( this.state.NUMBER_TYPE_ID, 10 ) === 0 ) {
      filterMessage += ' NUMDIALED';
    } else if ( parseInt( this.state.NUMBER_TYPE_ID, 10 ) === 1 ) {
      filterMessage += ' IPADDRESS';
    } else {
      filterMessage += ' All Number Types';
    }

    if ( parseInt( this.state.ACTIVE, 10 ) === 0 ) {
      filterMessage += ' and Not Active';
    } else if ( parseInt( this.state.ACTIVE, 10 ) === 1 ) {
      filterMessage += ' and Active';
    } else {
      filterMessage += ' and All Not Active/Active';
    }

    filterMessage += '.';

    let addNumberTypeFields = (
      <div key="wholesale-default-programs-filter-1" className="wholesale-default-programs-filters">
        <span className="wholesale-default-programs-field">
          <span id="header">Filter:</span>
        </span>
        <span className="wholesale-default-programs-field">
          <span>
            Number Type
            </span>
          <select value={this.state.NUMBER_TYPE} onChange={this.onChangeNumberType}>
            {this.onRenderNumberTypeOptions( false )}
          </select>
        </span>
        <span className="wholesale-default-programs-field">
          <span>
            Active
            </span>
          <select value={this.state.ACTIVE} onChange={this.onChangeActive}>
            {this.onRenderActiveOptions( false )}
          </select>
        </span>
        <span className="wholesale-default-programs-field">
          <button className="dialog-save-button" onClick={this.onNewItem} style={{ "width": "250px" }}>
            New Number/IP Address
            </button>
        </span>
        <span className="wholesale-default-programs-field">
          <label>{filterMessage}</label>
        </span>
      </div>
    );
    if ( this.state.addNewItem === true ) {
      let numberDialedPlaceHolder = 'Number Dialed';
      if ( parseInt( this.state.newItem.NUMBER_TYPE_ID, 10 ) === 1 ) {
        numberDialedPlaceHolder = 'IP Address';
      }
      addNumberTypeFields = (
        <div key="wholesale-default-programs-filter-2" className="wholesale-default-programs-filters">
          <span className="wholesale-default-programs-field">
            <span id="header">Add New:</span>
          </span>
          <span className="wholesale-default-programs-field">
            <select value={this.state.newItem.NUMBER_TYPE_ID} onChange={this.onChangeNumberType}>
              {this.onRenderNumberTypeOptions( true )}
            </select>
          </span>
          <span className="wholesale-default-programs-field">
            <input type="textbox" value={this.state.newItem.NUMBER_DIALED} onChange={this.onChangeNumberDialed} placeholder={numberDialedPlaceHolder} />
          </span>
          <span className="wholesale-default-programs-field">
            <span>
              Default Programs
            </span>
            <input style={{ "width": "600px" }} type="textbox" value={this.state.newItem.DEFAULT_PROGRAMS} placeholder='Comma delimited string of PDNIS' onChange={this.onDefaultProgramChange} />
          </span>
          <span className="wholesale-default-programs-field">
            <span>
              Active
            </span>
            <select value={this.state.newItem.ACTIVE} onChange={this.onChangeActive}>
              {this.onRenderActiveOptions( true )}
            </select>
          </span>
          <span className="wholesale-default-programs-field">
            <button className="dialog-cancel-button" onClick={this.onCancelItem}>
              Cancel
            </button>
            <button className="dialog-save-button" onClick={this.onSaveItem}>
              Save
            </button>
          </span>
        </div>
      );
    }
    return (
      <div className="wholesale-default-programs">
        {addNumberTypeFields}
        <div className="wholesale-default-programs-number-list">
          <WholesaleDefaultProgramsGrid
            rows={this.state.defaultPrograms}
            numberTypes={this.state.numberTypes}
            onUpdateItem={this.onUpdateItem}
            onDeleteItem={this.onDeleteItem}
            onCopyItem={this.onCopyItem}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleDefaultPrograms ) );


// WEBPACK FOOTER //
// ./src/content/wholesale/companies/components/WholesaleDefaultPrograms.js